export const AdminNavigation = [
  {
    title: 'DASHBOARD',
    routing: 'dashboard'
  },
  {
    title: 'USERS',
    routing: 'users'
  },
  {
    title: 'INVITEES',
    routing: 'invitees'
  },
  {
    title: 'PAYOUTS',
    routing: 'payouts'
  },
  {
    title: 'SETTINGS',
    routing: 'settings'
  },
  {
    title: 'JOINT FUNDS',
    sub: [
      {
        "title": "General Contributions",
        "routing": "general-contributions"
      },
      // {
      //   "title": "Personal Contributions",
      //   "routing": "personal-contributions"
      // },
      // {
      //   "title": "Contribution Settings",
      //   "routing": "jf-settings"
      // },
    ]
  },
  {
    title: 'LME 2029',
    sub: [
      {
        "title": "Dashboard",
        "routing": "lme-2029-dashboard"
      },
      {
        "title": "Settings",
        "routing": "lme-2029-settings"
      },
      // {
      //   "title": "Quick Loan",
      //   "routing": "lme-2029-admin-loan-requests"
      // },
      {
        "title": "LME 2029",
        "routing": "lme-2029-admin-lenders"
      }
    ]
  },
  // {
  //   title: 'BIT PLOT',
  //   sub: [
  //     {
  //       "title": "Settings",
  //       "routing": "bit-plot-settings"
  //     },
  //     {
  //       "title": "Buy Land Asset",
  //       "routing": "bit-plot-add-land-asset"
  //     },
  //     {
  //       "title": "Land Assets",
  //       "routing": "bit-plot-land-assets"
  //     },
  //     {
  //       "title": "Land Assets Transactions",
  //       "routing": "bit-plot-land-assets-transactions"
  //     }
  //   ]
  // },
  {
    title: 'LOGOUT',
    routing: 'logout'
  }
]

export const UserNavigation = [
  {
    title: 'HOME',
    routing: 'home'
  },

  {
    title: 'ACCOUNT',
    routing: 'account'
  },

  {
    title: 'INVITEES',
    routing: 'my-invitees'
  },
  {
    title: 'JOINT FUNDS',
    sub: [
      // {
      //   "title": "General Contributions",
      //   "routing": "general-contributions"
      // },
      {
        "title": "Personal Contributions",
        "routing": "personal-contributions"
      },
    ]
  },
  {
    title: 'LME 2029',
    sub: [
      {
        "title": "Dashboard",
        "routing": "my-lme-2029-dashboard"
      },
      // {
      //   "title": "Quick Loan",
      //   "routing": "my-lme-2029-deposit-history"
      // },
      {
        "title": "LME 2029",
        "routing": "my-lme-2029-loan-history"
      },
      // {
      //   "title": "Request Loan",
      //   "routing": "my-lend-request-loan"
      // }
    ]
  },
  // {
  //   title: 'BIT PLOT',
  //   sub: [
  //     {
  //       "title": "Land Assets",
  //       "routing": "my-bit-plot-land-assets"
  //     },
  //     {
  //       "title": "Land Assets Transactions",
  //       "routing": "my-bit-plot-land-assets-transactions"
  //     },
  //   ]
  // },
  {
    title: 'LOGOUT',
    routing: 'logout-user'
  }
]
